// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HFc4f","col":"styles_col__3-M7H"};